import React, { useEffect, useState } from "react";
import { SuperBlockStages, SuperBlocks, superBlockOrder } from '../../../../shared/config/superblocks';
import { useTranslation } from 'react-i18next';
import { SuperBlockIcon } from '../../assets/icons/superblock-icon';
import { Link, Spacer } from '../../components/helpers';
import { getSuperBlockTitleForMap } from '../../utils/superblock-map-titles';
import { getSuperBlockIntroForMap } from '../../utils/superblock-map-intro';
import { showUpcomingChanges } from '../../../config/env.json';
import Login from '../../components/Header/components/login';
import LoginToSee from '../../components/Header/components/logintosee';
import { useSelector } from 'react-redux';
import { isSignedInSelector, userSelector } from "../../redux/selectors";
import { User } from "../../redux/prop-types";
import { Alert } from '@freecodecamp/ui';

interface MapProps {
  forLanding?: boolean;
  user?: User;
}

const linkSpacingStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const coreCurriculum = [
//   ...superBlockOrder[SuperBlockStages.Backend],
...superBlockOrder[SuperBlockStages.NetworkSecurity] || [],
 ...superBlockOrder[SuperBlockStages.Python] || [],
//  ...superBlockOrder[SuperBlockStages.SecureStaticSites] || [], // Add fallback empty array
//  ...superBlockOrder[SuperBlockStages.NetworkSecurity] || [], // Add fallback empty array
  // ...superBlockOrder[SuperBlockStages.Professional],
  // ...superBlockOrder[SuperBlockStages.Legacy],
  // ...superBlockOrder[SuperBlockStages.New],
];

interface MapLiProps {
  superBlock: SuperBlocks;
  landing?: boolean;
  user?: User;
}

function MapLi({ superBlock, landing = false, user }: MapLiProps) {
  const isSignedIn = useSelector(isSignedInSelector);
  const userData = useSelector(userSelector);
  const currentUser = user || userData;
  const [showAlert, setShowAlert] = useState(false);

  const superBlockTitle = getSuperBlockTitleForMap(superBlock);

  // Check if user has special email to unlock all
  const isSpecialUser = currentUser?.email === "fagroudfatimazahra0512@gmail.com";

  // Certifications sequence logic
  const hasCompletedDataVis = isSpecialUser || currentUser?.is2018DataVisCert;
  const hasCompletedRelationalDatabase = isSpecialUser || currentUser?.isRelationalDatabaseCertV8;
  const hasCompletedDataAnalysis = isSpecialUser || currentUser?.isDataAnalysisPyCertV7;

  const isDataVis = superBlockTitle === "Data Visualization Certification";
  const isRelationalDatabase = superBlockTitle === "Relational Database Certification";
  const isDataAnalysis = superBlockTitle === "Data Analysis with Python Certification";

  const canAccessRelationalDatabase = isSpecialUser || hasCompletedDataVis;
  const canAccessDataAnalysis = isSpecialUser || hasCompletedRelationalDatabase;

  const isDisabled = !isSpecialUser && (
    (isRelationalDatabase && !canAccessRelationalDatabase) ||
    (isDataAnalysis && !canAccessDataAnalysis)
  );

  const alertMessage = "You need to complete the previous certification to access this content.";

  const handleClick = (e: React.MouseEvent) => {
    if (isDisabled) {
      e.preventDefault();
      setShowAlert(true);
    }
  };

  useEffect(() => {
    console.log(currentUser?.is2018DataVisCert);
    console.log(currentUser?.isDataAnalysisPyCertV7);
  }, []);

  return (
    <li
      data-test-label="curriculum-map-button"
      className={`${isDisabled ? "card disabled-card" : "card"}`}
    >
      {isSignedIn ? (
        <Link
          className="card-link"
          to={isDisabled ? "#" : `/learn/${superBlock}/`}
          onClick={handleClick}
        >
          <div
            className={`${
              isDisabled ? "disabled-container card-container" : "card-container"
            }`}
          >
            <SuperBlockIcon className="map-icon" superBlock={superBlock} />
            <div className="card-body">
              <div className="card-title">{superBlockTitle}</div>
              <p className="card-text">{getSuperBlockIntroForMap(superBlock)}</p>
              <button
                onClick={handleClick}
                disabled={isDisabled}
                className={`${isDisabled ? "disabled-button" : "details-button"}`}
              >
                {isDisabled ? (
                  <>
                    <svg
                      width="25px"
                      height="auto"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 14.5V16.5M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
                        stroke="#ffffff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </>
                ) : (
                  "See More Details"
                )}
              </button>
            </div>
          </div>
        </Link>
      ) : (
        <div className={`${isDisabled ? "disabled-container" : "card-container"}`}>
          <SuperBlockIcon className="map-icon" superBlock={superBlock} />
          <div className="card-body">
            <div className="card-title">{superBlockTitle}</div>
            <p className="card-text">{getSuperBlockIntroForMap(superBlock)}</p>
            <button className={`${isDisabled ? "disabled-button" : "details-button"}`}>
              <LoginToSee />
            </button>
          </div>
        </div>
      )}

      {showAlert && isDisabled && (
        <Alert variant="warning" onClose={() => setShowAlert(false)}>
          {alertMessage}
        </Alert>
      )}

      <style jsx>{`
        .disabled-button {
          width: 100%;
          padding: 10px 30px;
          gap: 10px;
          border-radius: 10px;
          background: #432b84;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .disabled-button:hover {
          background: #432b84;
        }
        .details-button {
          width: 100%;
          padding: 10px 30px;
          gap: 10px;
          border-radius: 10px;
          background: #432b84;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .details-button:hover {
          background: #432b84;
        }
      `}</style>
    </li>
  );
}

const Secuirity = () => {
  const { t } = useTranslation();

  return (
    <section className="container">
      <div className="map-ui" data-test-label="curriculum-map">
        <h2 className="content-title-cards">Information Security</h2>
        <ul>
          {coreCurriculum.map((superBlock, i) => (
            <MapLi key={i} superBlock={superBlock} landing={false} />
          ))}
        </ul>

        <Spacer size="medium" />

        {showUpcomingChanges && (
          <>
            <h2 className="content-title-cards">Upcoming Certifications</h2>
            <ul>
              {superBlockOrder[SuperBlockStages.Upcoming].map((superBlock, i) => (
                <MapLi key={i} superBlock={superBlock} landing={false} />
              ))}
            </ul>
          </>
        )}
      </div>
    </section>
  );
};

export default Secuirity;